import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { List } from 'lucide-react';

interface MenuNodeData {
  label?: string;
  title?: string;
  variable?: string;
  options?: Array<{
    label: string;
    value?: string;
    description?: string;
    emoji?: string;
  }>;
  invalidMessage?: string;
}

const MenuNode: React.FC<NodeProps<MenuNodeData>> = ({ data, selected }) => {
  return (
    <div
      className={`px-4 py-3 shadow-lg rounded-lg border-2 min-w-[200px] ${
        selected
          ? 'border-purple-500 bg-purple-50'
          : 'border-purple-300 bg-white'
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="w-3 h-3 !bg-purple-500"
      />

      <div className="flex items-center gap-2 mb-2">
        <div className="p-1.5 bg-purple-100 rounded">
          <List className="w-4 h-4 text-purple-600" />
        </div>
        <span className="font-medium text-sm text-gray-700">
          {data.label || 'Menu Interativo'}
        </span>
      </div>

      {data.title && (
        <div className="text-xs text-purple-600 font-medium mb-1 truncate">
          {data.title}
        </div>
      )}

      {data.options && data.options.length > 0 && (
        <div className="text-xs text-gray-500 space-y-0.5 max-h-20 overflow-y-auto">
          {data.options.slice(0, 4).map((option, index) => (
            <div key={index} className="flex items-center gap-1">
              <span className="text-purple-500">{index + 1}.</span>
              <span className="truncate">{option.label}</span>
            </div>
          ))}
          {data.options.length > 4 && (
            <div className="text-gray-400 italic">
              +{data.options.length - 4} mais...
            </div>
          )}
        </div>
      )}

      {data.variable && (
        <div className="mt-1.5 text-xs text-gray-400">
          Variavel: {data.variable}
        </div>
      )}

      <Handle
        type="source"
        position={Position.Bottom}
        className="w-3 h-3 !bg-purple-500"
      />
    </div>
  );
};

export default memo(MenuNode);
